var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.loading } },
    [
      _c(
        "vxe-grid",
        _vm._b(
          {
            ref: "xGrid",
            staticClass: "column-sortable-grid",
            attrs: { "column-key": "", "auto-resize": true },
            on: {
              "cell-click": _vm.cellClick,
              "cell-dblclick": _vm.cellDbClick,
            },
          },
          "vxe-grid",
          _vm.gridOptions,
          false
        ),
        [_c("template", { slot: "default" })],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }